import { Link, Inserter, SessionRole, SessionLogout } from "nystem-components";
import React from "react";
import app from "nystem";

const PartAdmin = () => (
  <div>
    <SessionRole userrole="super config" className="admin container">
      <Inserter match="/admin*" className="admin-container container p-3">
        <div>
          <h1>Admin</h1>
          <div className="ml-3 mb-10 flex items-center">
            <Link className="mr-3" to="/admin" match="/admin/page*">
              {app.t("Pages")}
            </Link>
            <SessionRole userrole="super">
              <Link
                className="mr-3 flex-grow"
                to="/admin/user/list"
                match="/admin/user*"
              >
                {app.t("Users")}
              </Link>
            </SessionRole>
            <SessionLogout
              type="button"
              className="btn-secondary float-right rounded border border-gray-300 bg-gray-200 py-2 px-4 text-base text-gray-900 shadow-sm hover:bg-gray-300"
              to="/admin"
            >
              {app.t("Log out")}
            </SessionLogout>
          </div>
        </div>
        <div>
          <Inserter match="/admin" source="/page/list" />
          <Inserter match="/admin/page*" source="/page*" />
          <Inserter match="/admin/user*" source="/user*" />
        </div>
      </Inserter>
    </SessionRole>
    <SessionRole userrole="logged-out user">
      <Inserter
        className="blog container"
        source="/user/login"
        match="/admin*"
      />
    </SessionRole>
  </div>
);
export default PartAdmin;
